import axios from 'axios'
import { userHelper } from '@/store/modules/auth/actions';

export default {
    /**
     *
     * @param state
     * @param payload
     * @returns {Promise<axios.AxiosResponse<any>>}
     */
    async postInvoiceAction(state, payload) {
        const url = '/invoices/upload-orders-presale-web';
        try {
            const response = await axios.post(url, payload);
            return response
        } catch (error) {
            console.log(error)
        }
    },

    async listInvoicesAction(context) {
        const url = `/invoices/data-invoices-trackings`;
        try {
            const response = await axios.get(url);
            if (response.data) {
                //console.log("Respuesta de API de facturas:", response.data);
                sessionStorage.setItem('invoicesLists', JSON.stringify(response.data));
                context.commit('setListInvoices', {
                    invoicesLists: response.data,
                });
                return response;
            } else {
                console.error("La respuesta de la API no contiene datos");
                return null;
            }
        } catch (error) {
            console.error("Error en listInvoicesAction:", error);
            return null;
        }
    },
    async sendListInvoices(context, payload) {
        const url = payload;
        try {
            const response = await axios.get(url);
            sessionStorage.setItem('invoicesLists', JSON.stringify(response.data));
            context.commit('setListInvoices', {
                invoicesLists: response.data,
            });
            return response
        } catch (error) {
            console.log(error)
        }
    },
    async tryListInvoice(context) {
        try {
            const invoices = JSON.parse(sessionStorage.getItem('invoicesLists'));
            if (invoices) {
                await context.commit('setInvoiceListsPos', {
                    invoicesLists: invoices,
                });
            }
            return invoices;
        } catch (error) {
            console.log(error)
        }
    },
    async listReceptions(context) {
        const url = `/receptions/data-reception`;
        try {
            const response = await axios.get(url);
            sessionStorage.setItem('reception_lists', JSON.stringify(response.data));
            context.commit('setReceptionsLists', {
                receptionLists: response.data,
            });
            return response
        } catch (error) {
            console.log(error)
        }
    },
    async tryListReceptions(context) {
        try {
            const reception = JSON.parse(sessionStorage.getItem('reception_lists'));
            console.log(reception);
            await context.commit('setReceptionsLists', {
                receptionLists: reception,
            });
            return reception;
        } catch (error) {
            console.log(error)
        }
    },

    async pagesInvoices(context, payload) {
        try {
            const response = await axios.get(payload);

            sessionStorage.setItem('invoicesLists', JSON.stringify(response.data));
            await context.commit('setInvoiceListsPos', {
                customersLists: response.data
            });
            return response
        } catch (error) {
            console.log(error)

        }
    },
    async fetchNumerationAction(context) {
        const numerationStr = sessionStorage.getItem('numeration');
        
        try {
            // Parseamos la numeración que ahora es un array de objetos
            const numerationArray = JSON.parse(numerationStr);
            
            // Buscamos la numeración para pedidos (sale_type = 2)
            let orderNumeration = null;
            if (Array.isArray(numerationArray)) {
                const orderEntry = numerationArray.find(item => item.sale_type === 2);
                orderNumeration = orderEntry ? orderEntry.number : null;
            } else {
                // Fallback para estructura antigua (número simple)
                orderNumeration = numerationArray;
            }

            // Usamos el helper para obtener los datos del usuario
            const user = userHelper.getUserData();

            // Si no tenemos usuario en el helper, intentamos obtenerlo del sessionStorage
            const userData = user || JSON.parse(sessionStorage.getItem('user'));

            if (orderNumeration === null) {
                console.warn('No se encontró numeración para pedidos (sale_type = 2)');
                orderNumeration = 0; // valor por defecto
            }

            // Convertimos numeration a número para poder sumar correctamente
            const numerationNum = parseInt(orderNumeration, 10);
            const nextNum = numerationNum + 1;

            let formNumeration;
            switch (nextNum.toString().length) {
                case 1:
                    formNumeration = userData.id + '02-00000' + nextNum;
                    break;
                case 2:
                    formNumeration = userData.id + '02-0000' + nextNum;
                    break;
                case 3:
                    formNumeration = userData.id + '02-000' + nextNum;
                    break;
                case 4:
                    formNumeration = userData.id + '02-00' + nextNum;
                    break;
                case 5:
                    formNumeration = userData.id + '02-0' + nextNum;
                    break;
                default:
                    formNumeration = userData.id + '02-' + nextNum;
            }

            await context.commit('setNumeration', {
                numeration: formNumeration
            });
        } catch (error) {
            console.error('Error al procesar numeración:', error);
            // Fallback en caso de error
            await context.commit('setNumeration', {
                numeration: '1-02-00001'
            });
        }
    },
    async updateNumerationAction(context, payload) {
        try {
            const numerationStr = sessionStorage.getItem('numeration');
            let numerationArray = JSON.parse(numerationStr);
            
            // Extraer el número del payload
            let newNumber;
            if (typeof payload === 'string' && payload.includes('-')) {
                let parts = payload.split('-');
                if (parts.length > 1) {
                    // Extraemos solo el número (última parte después del último guión)
                    let numPart = parts[parts.length - 1];
                    newNumber = parseInt(numPart, 10);
                }
            } else {
                newNumber = parseInt(payload, 10);
            }
            
            if (isNaN(newNumber)) {
                console.error('Número de numeración inválido:', payload);
                return;
            }
            
            // Si la numeración es un array (nueva estructura)
            if (Array.isArray(numerationArray)) {
                // Actualizar solo la numeración de pedidos (sale_type = 2)
                const orderIndex = numerationArray.findIndex(item => item.sale_type === 2);
                if (orderIndex !== -1) {
                    numerationArray[orderIndex].number = newNumber;
                    console.log("Actualizando numeración de pedidos a:", newNumber);
                    sessionStorage.setItem('numeration', JSON.stringify(numerationArray));
                } else {
                    console.warn('No se encontró entry para sale_type = 2 en numeración');
                }
            } else {
                // Estructura antigua - mantener compatibilidad
                console.log("Actualizando numeración (estructura antigua) a:", newNumber);
                sessionStorage.setItem('numeration', JSON.stringify(newNumber));
            }
        } catch (error) {
            console.error('Error al actualizar numeración:', error);
        }
    },

    // Nuevas acciones para Notas de Crédito (sale_type = 5)
    async fetchCreditNoteNumerationAction(context) {
        const numerationStr = sessionStorage.getItem('numeration');
        
        try {
            // Parseamos la numeración que ahora es un array de objetos
            const numerationArray = JSON.parse(numerationStr);
            
            // Buscamos la numeración para notas de crédito (sale_type = 5)
            let creditNoteNumeration = null;
            if (Array.isArray(numerationArray)) {
                const creditNoteEntry = numerationArray.find(item => item.sale_type === 5);
                creditNoteNumeration = creditNoteEntry ? creditNoteEntry.number : null;
            } else {
                // Fallback para estructura antigua (número simple)
                creditNoteNumeration = numerationArray;
            }

            // Usamos el helper para obtener los datos del usuario
            const user = userHelper.getUserData();

            // Si no tenemos usuario en el helper, intentamos obtenerlo del sessionStorage
            const userData = user || JSON.parse(sessionStorage.getItem('user'));

            if (creditNoteNumeration === null) {
                console.warn('No se encontró numeración para notas de crédito (sale_type = 5)');
                creditNoteNumeration = 0; // valor por defecto
            }

            // Convertimos numeration a número para poder sumar correctamente
            const numerationNum = parseInt(creditNoteNumeration, 10);
            const nextNum = numerationNum + 1;

            let formNumeration;
            switch (nextNum.toString().length) {
                case 1:
                    formNumeration = userData.id + '05-00000' + nextNum;
                    break;
                case 2:
                    formNumeration = userData.id + '05-0000' + nextNum;
                    break;
                case 3:
                    formNumeration = userData.id + '05-000' + nextNum;
                    break;
                case 4:
                    formNumeration = userData.id + '05-00' + nextNum;
                    break;
                case 5:
                    formNumeration = userData.id + '05-0' + nextNum;
                    break;
                default:
                    formNumeration = userData.id + '05-' + nextNum;
            }

            await context.commit('setCreditNoteNumeration', {
                numeration: formNumeration
            });
        } catch (error) {
            console.error('Error al procesar numeración de notas de crédito:', error);
            // Fallback en caso de error
            await context.commit('setCreditNoteNumeration', {
                numeration: '1-05-00001'
            });
        }
    },

    async updateCreditNoteNumerationAction(context, payload) {
        try {
            const numerationStr = sessionStorage.getItem('numeration');
            let numerationArray = JSON.parse(numerationStr);
            
            // Extraer el número del payload
            let newNumber;
            if (typeof payload === 'string' && payload.includes('-')) {
                let parts = payload.split('-');
                if (parts.length > 1) {
                    // Extraemos solo el número (última parte después del último guión)
                    let numPart = parts[parts.length - 1];
                    newNumber = parseInt(numPart, 10);
                }
            } else {
                newNumber = parseInt(payload, 10);
            }
            
            if (isNaN(newNumber)) {
                console.error('Número de numeración inválido para nota de crédito:', payload);
                return;
            }
            
            // Si la numeración es un array (nueva estructura)
            if (Array.isArray(numerationArray)) {
                // Actualizar solo la numeración de notas de crédito (sale_type = 5)
                const creditNoteIndex = numerationArray.findIndex(item => item.sale_type === 5);
                if (creditNoteIndex !== -1) {
                    numerationArray[creditNoteIndex].number = newNumber;
                    console.log("Actualizando numeración de notas de crédito a:", newNumber);
                    sessionStorage.setItem('numeration', JSON.stringify(numerationArray));
                } else {
                    console.warn('No se encontró entry para sale_type = 5 en numeración');
                }
            } else {
                // Estructura antigua - mantener compatibilidad
                console.log("Actualizando numeración (estructura antigua) para nota de crédito a:", newNumber);
                sessionStorage.setItem('numeration', JSON.stringify(newNumber));
            }
        } catch (error) {
            console.error('Error al actualizar numeración de nota de crédito:', error);
        }
    },

    // Acción para enviar nota de crédito
    async postCreditNoteAction(state, payload) {
        const url = '/invoices/upload-credit-note-web'; // Asumiendo endpoint específico
        try {
            const response = await axios.post(url, payload);
            return response
        } catch (error) {
            console.log('Error al enviar nota de crédito:', error)
            // Fallback al endpoint general si no existe específico
            const fallbackUrl = '/invoices/upload-orders-presale-web';
            try {
                const fallbackResponse = await axios.post(fallbackUrl, payload);
                return fallbackResponse
            } catch (fallbackError) {
                console.log('Error en fallback:', fallbackError)
                throw fallbackError
            }
        }
    }

}
